import React, { useState } from 'react';
import ElsterSubmissionAndDataChange from '../technicalProof/submit_application/ElsterSubmissionAndDataChange';
import elsterSubmissionAndDataChangeService from '../services/claim_project_reports/elster_submission_and_data_change.service';
import FinancialYearModal from './add_financial_year/FinancialYearModal';
import { useTranslation } from 'react-i18next';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
const ElsterDateUpdate = _ref => {
  let {
    companyId,
    elster,
    setLoading,
    loading,
    afterSubmitActions
  } = _ref;
  const [showFinancialYearModal, setShowFinancialYearModal] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    updateSubmitStatus,
    submitStatus: lastSubmitStatus,
    interval: fetchSubmitStatusInterval
  } = elsterSubmissionAndDataChangeService.useUpdateCrud(companyId, elster.id, setLoading, 'elsterApi', 'updateElsterDateStatusApi');
  return /*#__PURE__*/React.createElement(React.Fragment, null, showFinancialYearModal && /*#__PURE__*/React.createElement(FinancialYearModal, {
    show: showFinancialYearModal,
    onHide: () => setShowFinancialYearModal(false),
    companyId: companyId,
    elster: elster,
    startDate: elster === null || elster === void 0 ? void 0 : elster.start_date,
    endDate: elster === null || elster === void 0 ? void 0 : elster.end_date,
    warningMessage: t('date_change_could_result_in_data_loss_of_removed_projects'),
    showPreviousElsterDates: true,
    updateElsterAction: updateSubmitStatus
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: () => setShowFinancialYearModal(true),
    className: "ms-auto me-3"
  }, t('change_date')), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: '30px',
      width: '250px'
    }
  }, /*#__PURE__*/React.createElement(ElsterSubmissionAndDataChange, {
    setLoading: setLoading,
    loading: loading,
    createSubmitStatus: updateSubmitStatus,
    lastSubmitStatus: lastSubmitStatus,
    fetchSubmitStatusInterval: fetchSubmitStatusInterval,
    showRetryIfFailed: false,
    afterIntervalEndedCallback: afterSubmitActions
  })));
};
export default ElsterDateUpdate;